<template>
  <div>
    <ca-loader v-if="showLoading"></ca-loader>

    <template v-else>
      <ca-row vertical-offset="2">
        <ca-col>
          <worker-basic-info :basic-info="workerBasicInfo"></worker-basic-info>
        </ca-col>
      </ca-row>

      <ca-row vertical-offset="4">
        <ca-col>
          <worker-job-info
            :worker="workerBasicInfo"
            :job-info="worker.jobInfo"></worker-job-info>
        </ca-col>
      </ca-row>

      <ca-row vertical-offset="4">
        <ca-col>
          <worker-contract-info
            :worker="workerBasicInfo"
            :contract-info="worker.contractInfo"></worker-contract-info>
        </ca-col>
      </ca-row>

      <ca-row vertical-offset="4">
        <ca-col class="ca-u-margin-bottom">
          <worker-shift-info
            :shift-board="worker.shiftBoard"
            :worker="workerBasicInfo"
            :job-info="worker.jobInfo"></worker-shift-info>
        </ca-col>
      </ca-row>
    </template>
  </div>
</template>

<script>
import { getErrorMessageFromResponse } from 'packages/common';
import WorkerBasicInfo from 'accountant/worker/src/modules/workers/components/WorkerBasicInfo';
import WorkerJobInfo from 'accountant/worker/src/modules/workers/components/info-job/WorkerJobInfo';
import WorkerContractInfo from 'accountant/worker/src/modules/workers/components/contract-info/WorkerContractInfo';
import WorkerShiftInfo from 'accountant/worker/src/modules/workers/components/shift-info/WorkerShiftInfo';
import {
  deleteWorker,
  getJobInfo,
  getContractInfo,
  getShiftInfo,
  hasCompleteRegistration,
} from 'accountant/worker/src/modules/workers/workersService';
import { REGISTRATION_STATUS } from 'accountant/worker/src/modules/workers/workerConstants';
import store from '../../../../../../store/index';

export default {
  name: 'WorkerContractDataView',
  components: {
    WorkerBasicInfo,
    WorkerJobInfo,
    WorkerContractInfo,
    WorkerShiftInfo,
  },
  data() {
    return {
      showLoading: true,
      worker: {
        jobInfo: null,
        contractInfo: null,
        shiftBoard: null,
      },
    };
  },
  computed: {
    workerBasicInfo() {
      return store.state.worker.basicInfo;
    },
    workerId() {
      return this.workerBasicInfo.id;
    },
  },
  created() {
    this.initData();
  },
  methods: {
    async initData() {
      if (hasCompleteRegistration(this.workerBasicInfo)) {
        this.getWorkerContractData();
      } else {
        this.$router.push({
          name: 'WorkerWizard',
          params: {
            id: this.workerId,
          },
          query: {
            step: REGISTRATION_STATUS[this.workerBasicInfo.statusInfo].step,
          },
        });
      }
    },
    async getWorkerContractData() {
      try {
        const [jobInfo, contractInfo, shiftBoard] = await Promise.all([
          getJobInfo(this.workerId),
          getContractInfo(this.workerId),
          getShiftInfo(this.workerId),
        ]);

        this.worker = { jobInfo, contractInfo, shiftBoard };
      } catch (error) {
        this.$toaster.error(getErrorMessageFromResponse(error));
      } finally {
        this.showLoading = false;
      }
    },
    onEdit() {
      this.$router.push({ name: 'EditWorker', params: { id: this.workerId } });
    },
    onDelete() {
      this.$caConfirm({
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente excluir esse funcionário?',
        onConfirm: () => {
          deleteWorker(this.workerId)
            .then(() => {
              this.$router.push({ name: 'WorkerPage' });
              this.$toaster.success('Funcionário excluído com sucesso');
            });
        },
      });
    },
    onJobDescriptionsHistory() {
      this.$router.push({
        name: 'WorkerChangeJobDescriptions',
        params: { id: this.workerId },
      });
    },
  },
};
</script>
